import {atom} from "nanostores";

export const $verse_start = atom("1")
export const $verse_end = atom("1")